<div #pdfContainer>

  <iframe #pdfEmbedSafari src="" style="overflow: auto; width: 100%; height: 100%;" type="application/pdf" class="pdf-frame" frameBorder="0"></iframe>
  
  <embed  #pdfEmbed class="pdf-frame" src="" type="application/pdf" style="overflow: auto; width: 100%; height: 100%;">
  
  
</div>
<p class="text-center"><small>{{ 'prestation_document_get_browser' | localise }} <a href="https://www.google.com/chrome/" target="_blank">Chrome</a>.</small></p>